/**
 * @format
 * @description Extends premiumArticle - Long read article page
 */
import mergeWith from "lodash/mergeWith";
import premiumSizeMapping from "./premium-article";
import { arrayMerge } from "utils/utils";

// Extends premiumArticle (see below)
const longReadSizeMapping = {
  mobile: {
    flexN: [[300, 250]]
  },
  portrait: {
    flexN: [[728, 90]]
  },
  landscape: {
    flexN: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 250]
    ]
  },
  desktop: {
    flexN: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 250]
    ]
  }
};

// Extend the long read article with premium article sizes
export default mergeWith(longReadSizeMapping, premiumSizeMapping, arrayMerge);
